<template>
  <div class="MultiContentComponent">
    <div class="contentPanel">
      <div class="contentBox" v-for="item in inputItems" :key="item.id">
        <div class="contentRow">
          <div
            v-if="item.contentPattern == 'audioText'"
            class="materialCardText"
          >
            <audio
              v-if="item.lessonContentTemplate.material.materialUrl"
              :src="item.lessonContentTemplate.material.materialUrl"
              :loop="false"
              controls
              preload="auto"
              controlsList="nodownload noplaybackrate"
            ></audio>
            <p style="padding: 10px">
              {{ item.lessonContentTemplate.material.displayAudioText }}
            </p>
          </div>

          <img
            v-if="item.contentPattern == 'image'"
            class="materialCardImage"
            :src="item.lessonContentTemplate.material.materialUrl"
          />

          <audio
            v-if="item.contentPattern == 'audio'"
            class="materialCardAudio"
            :src="item.lessonContentTemplate.material.materialUrl"
            :loop="false"
            controls
            preload="auto"
            controlsList="nodownload noplaybackrate"
          ></audio>

          <y-j-video
            v-if="item.contentPattern == 'video'"
            class="materialCardVideo"
            :src="item.lessonContentTemplate.material.materialUrl"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YJVideo from "@/components/video/index.vue";

export default {
  name: "MultiContentComponent",
  components: {YJVideo},
  props: {
    inputItems: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.contentPanel {
  padding: 10px;
  font-size: 16px;
  letter-spacing: 0.1em;
  line-height: 30px;
  display: flex;
  flex-direction: column;
  align-items: start;

  .contentBox {
    display: flex;
    flex-direction: column;
    align-items: center;

    .contentRow {
      display: flex;
      flex-direction: row;
      .contentOpration {
        width: 40px;

        .contentOprationItem {
          width: 40px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: solid 1px #999;
        }

        .contentOprationItem:hover {
          background-color: aliceblue;
          cursor: pointer;
        }
      }
    }

    .el-dropdown-link {
      cursor: pointer;
      color: #10689c;
    }
  }
}

.addButton {
  height: 36px;
  width: 400px;
}

.footer {
  position: absolute;
  text-align: center;
  bottom: 20px;
  right: 50px;
}

.materialCardText {
  // border: solid 1px #999;
  width: 360px;
}
.materialCardImage {
  // border: solid 1px #999;
  width: 360px;
}
.materialCardAudio {
  // border: solid 1px #999;
  width: 360px;
}
.materialCardVideo {
  // border: solid 1px #999;
  width: 360px;
}
//}
</style>
